var $ = require('jquery')
  , doc = $(document)
  , docElement = $('html')
  , tmpl = require('./tmpl.handlebars')
  , WIHTOUT_SCROLL_MARGIN_RIGHT = 0
  , body = $('body')
  , win = $(window)

function cacheable(func) {
  var cachedValue
    , hasRuned = false

  return function() {
    if (!hasRuned) {
      hasRuned = true
      cachedValue = func()
    }
    return cachedValue
  }
}

function getScrollbarWidth() {
  // Copy from http://tinyurl.com/k2wj4cm
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = "scroll";

  // add innerdiv
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
}

getScrollbarWidth = cacheable(getScrollbarWidth)

function Overlay(opts) {
  this.opts = opts
  this.el = $(tmpl()).appendTo('body')
  this.body = this.el.find('.overlay-in')
  this.closable = opts.closable !== void 0
    ? !!opts.closable : true

  this.setBody()
  this.el.addClass(opts.klass)

  if (!this.closable) { return }

  var overlay = this
  doc.on('click.close', '.overlay-wrap', function(e) {
    if (e.target !== e.currentTarget) { return }
    overlay.close()
  })
  .on('keyup.close', function(e) {
    var tagName = e.target.tagName
      , isEscKey = e.keyCode === 27
      , isInputField = /input|textarea/i.test(tagName)

    if (!isInputField && isEscKey) {
      overlay.close()
    }
  })
}

$.extend(Overlay.prototype, {
  close: function(silent) {
    this.el.remove()
    docElement.removeClass('overlay-show')
    docElement.css({ marginRight: WIHTOUT_SCROLL_MARGIN_RIGHT })
    doc.off('.close')

    //XXX: dirty but work, fix windows 下侧边栏分享组件浮动
    body.find('.pn-float').css({ left: '50%' })
    body.find('.pn-cycle').css({ right: '10px' })
    return this
  }

, getContentElement: function() {
    return this.el.find('.k-content')
  }

, open: function() {
    this.scrollTop = doc.scrollTop()

    //XXX: dirty but work, fix windows 下侧边栏分享组件浮动
    body.find('.pn-float').css({ left: win.width() / 2 })

    docElement.addClass('overlay-show')
    var scrollbarWidth = getScrollbarWidth()
    docElement.css({ marginRight: scrollbarWidth })

    //fix windows
    var pnCyclePositionX = scrollbarWidth + 10
    body.find('.pn-cycle').css({ right: pnCyclePositionX })

    this.el.show()
    return this
  }

, setBody: function(body) {
    body = body || this.opts.body
    this.body.html(body)
    return this
  }
})

module.exports = Overlay;
